export function setReceiverLicense(state, value) {
  state.receiverLicense = value;
}

export function setPickUpDate(state, value) {
  state.pickUpDate = value;
}

export function setDropOffDate(state, value) {
  state.dropOffDate = value;
}

export function setIsDropOff(state, value) {
  state.isDropOff = value;
}

export function setPackageModel(state, value) {
  state.packageModel = value;
}

export function setPackageTiming(state, value) {
  state.packageTiming = value;
}

export function resetTransferForm(state) {
  state.receiverLicense = null;
  state.pickUpDate = "";
  state.dropOffDate = "";
  state.isDropOff = false;
  state.packageModel = "packages";
  state.packageTiming = "now";
}
